import styled from 'styled-components'
import { spacing } from '@material-ui/system';

export const Div = styled.div`
    margin: 0;
    padding: 0;
`
export const PageDiv = styled(Div)`
    position: absolute;
    top: 0rem;
    bottom: 0rem;
    left: 0rem;
    right: 0rem;
`

export const TopBackgroundDiv = styled(Div)`
    background: #292929;
    box-sizing: border-box;
    height: 50vh;
    width: 100%;
    position: relative;
    z-index: 0;
`

export const BottomBackgroundDiv = styled(Div)`
    background: #FFFFFF;
    box-sizing: border-box;
    height: 50vh;
    width: 100%;
    position: relative;
    z-index: 0;
`

export const DarkDiv = styled(Div)`
    background: #292929;
    color: white;
`

export const WhiteDarkerDiv = styled(Div)`
    background: #F8F9FC;
    color: black;
`

export const WhiteDiv = styled(Div)`
    background: #ffffff;
    color: black;
`

export const BlueDiv = styled(Div)`
    background: #4267B2;
    color: white;
`

export const HeaderDiv = styled(Div)`
    position: absolute;
    width: 100%;
    top: 0;
`

export const ComponentsDiv = styled(Div)`
    position: absolute;
    top: 5rem;
    bottom: 0rem;
    width: 100%;
    overflow-y: auto;
`

export const CopyrightDiv = styled(Div)`
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    color: black;
`

export const SectionHeader = styled.h2`  
    margin: 0;
    padding: 0;
    padding-bottom: 1.2rem;
    ${spacing};
    font-size: 3.5rem;
`

export const Description = styled.p`
    ${spacing};
`

export const List = styled.ul`
    ${spacing};
`

export const ListItem = styled.li`
    ${spacing};
`

export const CopyrightText = styled.h5`
    margin: 0;
    padding: 1rem 0rem;
    font-size: 1.2rem;
`

export const ErrorText = styled.p`
    margin: 0;
    padding: 0;
    ${spacing};
    font-size: 1.3rem;
    color: red;
    overflow-wrap: break-word;
`

export const InputField = styled.input`
    margin: 0;
    padding: 0rem 0.2rem;
    box-sizing: border-box;
    border-radius: 0.3rem;
    border-style: solid;
    border-width: 0.1rem;
    border-color: #afafaf;
`

export const IconButton = styled.button`
    border: none;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: transparent;
    outline-style: none;
`

export const BlueTint = styled.span`
    margin: 0;
    padding: 0;
    color: #4267B2;
`

export const RedTint = styled.span`
    margin: 0;
    padding: 0;
    color: #e11313;
`

export const Alert = styled(Div)`
    width: 100%;
    z-index: 2;
    background: red;
    color: white;
    padding: 1.2rem 0rem;
    font-size: 1.6rem;
    text-align: center;
    border-radius: 0.8rem;
    border-style: solid;
    border-color: #585858;
    border-width: thin;
`

export const Info = styled(Div)`
    width: 100%;
    z-index: 2;
    background: #4267B2;
    color: white;
    padding: 1.2rem 0rem;
    font-size: 1.6rem;
    text-align: center;
    border-radius: 0.8rem;
    border-style: solid;
    border-color: #585858;
    border-width: thin;
`